// extracted by mini-css-extract-plugin
export default {"messagesContainer":"MessagesList_messagesContainer__ArjUq","messagesList":"MessagesList_messagesList__tOxkQ"};